import {Injectable, NgZone} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({providedIn: 'root'})
export class ToastService {

    constructor(
        private translateService: TranslateService,
        private toastService: ToastrService,
        private ngZone: NgZone
    ) {
    }

    success(text: string) {
        this.ngZone.run(() => this.toastService.success(this.translateService.instant(text)));
    }

    error(text: string) {
        this.ngZone.run(() => this.toastService.error(this.translateService.instant(text)));
    }

    info(text: string) {
        this.ngZone.run(() => this.toastService.info(this.translateService.instant(text)));
    }

    insertSuccess() {
        this.translateService.get('operations.insert.success').subscribe((message: string) => {
            this.success(message);
        });
    }

    insertError() {
        this.translateService.get('operations.insert.error').subscribe((message: string) => {
            this.error(message);
        });
    }

    updateSuccess() {
        this.translateService.get('operations.update.success').subscribe((message: string) => {
            this.success(message);
        });
    }

    updateError() {
        this.translateService.get('operations.update.error').subscribe((message: string) => {
            this.error(message);
        });
    }

    deleteSuccess() {
        this.translateService.get('operations.delete.success').subscribe((message: string) => {
            this.success(message);
        });
    }

    validationSuccess() {
        this.translateService.get('operations.validation.success').subscribe((message: string) => {
            this.success(message);
        });
    }

    validationError() {
        this.translateService.get('operations.validation.error').subscribe((message: string) => {
            this.error(message);
        });
    }
}
